import * as React from 'react'
import Student from "./Student";
import {
  Box, Button, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup, Switch, Tab
} from "@material-ui/core";


const DebugRadioGroup = ({group, groupValue, groupName, defaultValue, value, displayModeRow = true}) => {
  const [selectedValue, setSelectedValue] = React.useState(() => value ? value : defaultValue);

  React.useEffect(() => {
    if (value !== undefined && value !== selectedValue) {
      setSelectedValue(value);
    }
  }, [value]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Box sx={{borderRadius: 10, bgcolor: '#eeeeee', margin: '5px', padding: '5px'}}>
      <FormLabel id={`radio-${groupValue}`} style={{padding: '5px 10px'}}>{groupName}</FormLabel>
      <RadioGroup
        row={displayModeRow}
        aria-labelledby={`radio-${groupValue}`}
        name={groupValue}
        value={selectedValue}
        onChange={handleChange}
      >
        {group.map((g, i) => (
          <FormControlLabel value={g.value} control={<Radio />} label={g.label} key={g.value} />
        ))}
      </RadioGroup>
    </Box>
  )
}

const DebugSwitch = ({switchBool, value}) => {
  const [checkedValue, setSelectedValue] = React.useState(() => value ? value : switchBool.defaultValue);

  React.useEffect(() => {
    if (value !== undefined && value !== checkedValue) {
      setSelectedValue(value);
    }
  }, [value]);

  const handleChange = (event) => {
    setSelectedValue(event.target.checked);
  };

  return (
    <FormGroup>
      <FormControlLabel
        control={<Switch checked={checkedValue} name={switchBool.value} value={switchBool.value} label={switchBool.label} onChange={handleChange}/>}
        label={switchBool.label}
      />
    </FormGroup>
  )
}

export default () => {
  const { setStudent, student } = Student.useContainer();
  const copyStudent = JSON.parse(JSON.stringify(student));

  const departements = [
    { value: 'HEG', label: 'HEG' },
    { value: 'COMEM+', label: 'COMEM+' },
    { value: 'EC+G', label: 'EC+G' },
    { value: 'TIN', label: 'TIN' },
    { value: 'TIC', label: 'TIC' },
  ]

  const modes = [
    { value: 'Plein temps', label: 'Plein temps' },
    { value: 'Temps partiel', label: 'Temps partiel' },
    { value: 'En emploi', label: 'En emploi' },
    { value: '', label: 'Aucun' },
  ]

  const filieres = [
    { value: 'Energie et techniques environnementales', label: 'Energie et techniques environnementales' },
    { value: 'Génie électrique', label: 'Génie électrique' },
    { value: 'Microtechniques', label: 'Microtechniques' },
    { value: 'Systèmes industriels', label: 'Systèmes industriels' },
    { value: 'Ingénierie et gestion industrielles', label: 'Ingénierie et gestion industrielles' },
    { value: 'Génie territorial', label: 'Génie territorial' },
  ];

  const langues = [
    { value: 'Allemand', label: 'Allemand' },
    { value: 'Anglais', label: 'Anglais' },
    { value: '', label: 'Aucunes langues' },
  ]

  const profilLinguistiqueSubmitted = [
    { value: 'de', label: 'Allemand' },
    { value: 'en', label: 'Anglais' },
    { value: 'de,en', label: 'Les deux' },
    { value: '', label: 'Aucunes langues' },
  ]

  const switchBoolean = [
    { value: 'ahesFin', label: 'AHES Finalisé', defaultValue: true },
    { value: 'ahesFormSubmitted', label: 'AHES Form Soumis', defaultValue: false },
    { value: 'ahesFormValidated', label: 'AHES Form Validé', defaultValue: false },
    { value: 'ahesRequired', label: 'AHES Form Requis', defaultValue: false },
    { value: 'hasEduId', label: 'EDU ID présent', defaultValue: false },
    { value: 'visaRequired', label: 'Visa Requis', defaultValue: false },
    { value: 'visaAcquired', label: 'Visa Acquis', defaultValue: false },
  ]

  const compteAccesSwitchs = [
    { value: 'eduIDIsLinked', label: 'EDU ID est lié', defaultValue: true },
    { value: 'entraMfa', label: 'MFA Microsoft configuré', defaultValue: true },
    { value: 'mfaConfigured', label: 'MFA Configuré', defaultValue: true },
    { value: 'passwordHasBeenModified', label: 'Le mot de passe a été changé', defaultValue: true },
  ]

  function handleSubmit (event) {
    event.preventDefault();

    const formData = new FormData(event.target);
    const formProps = Object.fromEntries(formData);

    switchBoolean.forEach(s => {
      formProps[s.value] = formProps.hasOwnProperty(s.value);
    });

    formProps.firstName = 'Etudiant'
    formProps.lastName = formProps.departement;

    if (formProps.profilLinguistiqueSubmitted) {
      formProps.profilLinguistiqueSubmitted = formProps.profilLinguistiqueSubmitted.split(',');
    }
    setStudent({
      ...(student.canDebug && { canDebug: true }),
      ...formProps
    });
  }

  return (
    <form onSubmit={handleSubmit} >
      <FormControl style={{width: '100%'}}>
        <DebugRadioGroup
          group={departements}
          groupName='Departement'
          groupValue='departement'
          defaultValue='HEG'
          value={copyStudent.departement}
        />
        <DebugRadioGroup
          group={modes}
          groupName='Mode'
          groupValue='mode'
          defaultValue='Plein temps'
          value={copyStudent.mode}
        />
        <DebugRadioGroup
          displayModeRow={false}
          group={filieres}
          groupName='Filiere'
          groupValue='filiere'
          defaultValue='Microtechniques'
          value={copyStudent.filiere}
        />
        <DebugRadioGroup
          group={langues}
          groupName='Langue'
          groupValue='languages'
          defaultValue='Allemand'
          value={copyStudent.languages}
        />
        <DebugRadioGroup
          group={profilLinguistiqueSubmitted}
          groupName='Profil Linguistique Validé'
          groupValue='profilLinguistiqueSubmitted'
          defaultValue=''
          value={copyStudent.profilLinguistiqueSubmitted ? copyStudent.profilLinguistiqueSubmitted.toString() : ''}
        />
        <Box sx={{borderRadius: 10, bgcolor: '#eeeeee', margin: '5px', padding: '5px'}}>
          <label>Paramètres Divers</label>
          { switchBoolean.map((switchBool) => (
            <DebugSwitch
              key={switchBool.value}
              switchBool={switchBool}
              value={copyStudent[switchBool.value]}
            />
          ))}
        </Box>
        <Box sx={{borderRadius: 10, bgcolor: '#eeeeee', margin: '5px', padding: '5px'}}>
          <label>Compte D'accès</label>
          { compteAccesSwitchs.map((switchBool) => (
            <DebugSwitch
              key={switchBool.value}
              switchBool={switchBool}
              value={copyStudent[switchBool.value]}
            />
          ))}
        </Box>
        <Button style={{ margin: '10px', position: 'sticky', bottom: '15px' }} type="submit" color="primary" variant="contained">
          Simuler cet étudiant
        </Button>
      </FormControl>
    </form>
  )
}